import { render, staticRenderFns } from "./ProfileChangeLanguage.vue?vue&type=template&id=09c8ad63&scoped=true"
import script from "./ProfileChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ProfileChangeLanguage.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeLanguage.vue?vue&type=style&index=0&id=09c8ad63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8ad63",
  null
  
)

export default component.exports